/* -------------------------------------------------------------------------- *
 * Tabbed Content *
 * -------------------------------------------------------------------------- *
 * This is what this does.
 *
 *
 * ---------------------------- *
 * Tab Button Parent Attributes *
 * ---------------------------- *
 * role="tablist"
 * aria-label="Title for the Content"
 *
 * ---------------------- *
 * Tab Button Attributes *
 * ---------------------- *
 * The is-active class should only be used for the tab that is open by default
 * and should be in alignment with the value of the aria-selected attribute
 * (e.g. is-active = true)
 *
 * id="tab1"
 * class="js-tab is-active"
 * role="tab"
 * aria-selected="true"
 * aria-controls="js-tabPanel1"
 * data-group="tabGroup1"
 *
 * ------------------------------ *
 * Tab Content Element Attributes *
 * ------------------------------ *
 * The is-active class should only be used for the tab that is open by default
 *
 * id="js-tabPanel1"
 * class="is-active"
 * tabindex="-1"
 * role="tabpanel"
 * aria-labelledby="tab1"
 */

const settings = {
    selector: '.js-tab',
    state_class: 'is-active',
};

const groups_arr = [];

class TabButton {
    constructor(el) {
        const aria_selected = el.getAttribute('aria-selected');
        const aria_controls = el.getAttribute('aria-controls');
        const tab_group = el.getAttribute('data-group');

        this.trigger_el = el;
        this.target_el = document.getElementById(aria_controls);
        this.active = aria_selected === 'true';
        this.group = tab_group;

        // Add object to group array
        groups_arr[this.group] = groups_arr[this.group] || [];
        groups_arr[this.group].push(this);

        // Show tab content on click
        el.addEventListener('click', (e) => {
            e.preventDefault();
            this.switchTabs();
        });
    }

    switchTabs() {
        // Check if tab is already active
        if (this.active !== true) {
            // Close the current tab in the group
            groups_arr[this.group].forEach((tab) => {
                if (tab.active === true) {
                    tab.trigger_el.classList.remove(settings.state_class);
                    tab.trigger_el.setAttribute('aria-selected', false);
                    tab.target_el.classList.remove(settings.state_class);
                    tab.target_el.setAttribute('hidden', true);
                    tab.active = false;
                }
            });

            // Activate new tab
            this.trigger_el.classList.add(settings.state_class);
            this.trigger_el.setAttribute('aria-selected', true);
            this.target_el.classList.add(settings.state_class);
            this.target_el.removeAttribute('hidden');
            this.active = true;
        }

        this.target_el.focus();
    }
}

/* ------------- *
 * Public Export *
 * ------------- */

const Tabs = {
    selector: settings.selector,

    init(selector = settings.selector) {
        const tab_els = document.querySelectorAll(selector);
        const tab_arr = Array.from(tab_els);

        tab_arr.forEach((el) => new TabButton(el));
    },
};

export default Tabs;
